// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"d541bbe6","535":"3e561153","539":"f8c3d558","665":"631dee48","678":"43b6230f","795":"0d7efdf3","821":"772ba21a","863":"dd9e31b4"}[chunkId] + ".chunk.js";
};